export default {
  backgroundColor: "white",
  fontWeight: "normal",
  textAlign: "left",
  padding: "15px",
  borderBottom: "1px solid rgb(226, 226, 226)"
};
